jQuery(document).ready(function(){
    
    
    
    // OPEN/CLOSE
    
    var time_out = 300;
    var etheme_cp = jQuery('.etheme_cp');
    var btn_show = jQuery('.etheme_cp_btn_show');
    var btn_close = etheme_cp.find('.etheme_cp_head .etheme_cp_btn_close');
    
    if(jQuery.cookie('etheme_cp_closed') == 1){
        hide_cp(0);
    }else{
        show_cp(0);
    }
    
    function hide_cp(time){
        etheme_cp.animate({
            'left': '-200px' 
        },time, function() {
            btn_show.show().animate({
                'left':'0px'
            },time);
            jQuery.cookie('etheme_cp_closed', 1);
        }); 
    }    
    
    function show_cp(time){
        btn_show.animate({
            'left':'-60px'  
        },time, function() {
            etheme_cp.show().animate({
                'left':'0px'
            });
            jQuery.cookie('etheme_cp_closed', 0);
        });
    }
    
    btn_close.bind("click", function() {
        hide_cp(300);
    }); 
    
    btn_show.bind("click", function() {
        show_cp(300);
    }); 
    
    
    // Layout changing  
    
    var layoutSelector = etheme_cp.find('#layout-selector');
    var layoutClass = jQuery.cookie('etheme_layout_class');
    
    
    if(layoutClass) {
    	jQuery('.wrapper').attr('class','wrapper wrapper-' + layoutClass);
    	layoutSelector.val(layoutClass);
    }
    
    layoutSelector.change(function() { 
    
    	layoutClass = jQuery(this).val();
    	jQuery('.wrapper').attr('class','wrapper wrapper-' + layoutClass);
        jQuery.cookie('etheme_layout_class', layoutClass);
    });
      
    // Color changes
    
    var pattern_select = jQuery('.pattern_select');
    var btn_clear_pattern = jQuery('.clear_patern');
    var pattern_selected = jQuery.cookie('pattern');
    var pattern_selected_id = jQuery.cookie('pattern_selected_id');
    
    if(pattern_selected_id){
        var selector1 = '#' + pattern_selected_id;
        jQuery(selector1).addClass('selected');
    }
    
    if(pattern_selected){
        jQuery('body').css({
            'backgroundImage' : pattern_selected
        });
    }
    
    function clearPattern(){
        jQuery.cookie('pattern', null);
        jQuery.cookie('pattern_selected_id', null);
        jQuery('.pattern_select').each(function(){
            jQuery(this).removeClass('selected');
        });
        jQuery('body').css({
            'backgroundImage' : pattern_default
        });
    }
    

    function choose_pattern(pattern_block){
    	if(layoutClass == 'wide'){
     		alert('You must select boxed layout.');
	    	return false;
    	}
        var pattern_chosed = pattern_block.css('backgroundImage');
        jQuery('.pattern_select').each(function(){
            jQuery(this).removeClass('selected');
        });
        pattern_block.addClass('selected');
        jQuery('body').css({
            'backgroundImage' : pattern_chosed
        });
        jQuery.cookie('pattern', pattern_chosed);
        jQuery.cookie('pattern_selected_id', pattern_block.attr('id'));
    }
    
    btn_clear_pattern.bind("click", function() {
        clearPattern();
    });        
    pattern_select.bind("click", function() {
        choose_pattern(jQuery(this));
    });  
    
    // COLORPICKER
    var bg_color = jQuery.cookie('bg_color');
    var active_color = jQuery.cookie('active_color');
    var btn_clear_color = jQuery('.clear_color');
    var color_selector_div = jQuery('.colorSelector');
    var color_selector_div2 = jQuery('.colorSelector2');
    
    
    // Active Color
    
        
    if(active_color){
        color_picker1 = active_color;
        jQuery(active_color_selector).css({
            'color' : '#' + active_color
        });  
        jQuery(active_bg_selector).css({
            'backgroundColor' : '#' + active_color
        });  
        jQuery(active_border_selector).css({
            'borderColor' : '#' + active_color
        });     
    }else{
        color_picker1 = active_color_default;
    }
    
    color_selector_div2.find('div').css({
        'backgroundColor' : '#' + color_picker1
    });

    color_selector_div2.ColorPicker({
    	color: '#' + color_picker1,
        cssclass: 'picker2',
    	onShow: function (colpkr) {
    		jQuery(colpkr).fadeIn(500);
    		return false;
    	},
    	onHide: function (colpkr) {
    		jQuery(colpkr).fadeOut(500);
    		return false;
    	},
    	onChange: function (hsb, hex, rgb) {
    		color_selector_div2.find('div').css('backgroundColor', '#' + hex);
    		jQuery(active_color_selector).css('color', '#' + hex);
            jQuery(active_bg_selector).css({
                'backgroundColor' : '#' + hex
            });  
            jQuery(active_border_selector).css({
                'borderColor' : '#' + hex
            });             
            jQuery.cookie('active_color', hex);
    	}
    })    .bind('keyup', function(){
    	jQuery(this).ColorPickerSetColor(this.value);
    });      
        
    function clearBgColor(){
        jQuery.cookie('bg_color', null);
        jQuery.cookie('active_color', null);
        jQuery(active_color_selector).css({
            'color' : '#' + active_color_default
        });
        jQuery(active_bg_selector).css({
            'backgroundColor' : '#' + active_color_default
        });  
        jQuery(active_border_selector).css({
            'borderColor' : '#' + active_color_default
        });         
        jQuery('body').css({
            'backgroundColor' : '#' + bg_default
        });
    }
    
    // BG Color
    if(bg_color){
        color_picker = bg_color;
    }else{
        color_picker = bg_default;
    }
    
    color_selector_div.find('div').css({
        'backgroundColor' : '#' + color_picker
    });
    
    if(bg_color){
        jQuery('body').css({
            'backgroundColor' : '#' + bg_color
        });
    }
    color_selector_div.ColorPicker({
    	color: '#' + color_picker,
        cssclass: 'picker1',
    	onShow: function (colpkr) {
    		jQuery(colpkr).fadeIn(500);
    		return false;
    	},
    	onHide: function (colpkr) {
    		jQuery(colpkr).fadeOut(500);
    		return false;
    	},
    	onChange: function (hsb, hex, rgb) {
    		color_selector_div.find('div').css('backgroundColor', '#' + hex);
    		jQuery('body').css('backgroundColor', '#' + hex);
            jQuery.cookie('bg_color', hex);
    	}
    })    .bind('keyup', function(){
    	jQuery(this).ColorPickerSetColor(this.value);
    });
    
    btn_clear_color.bind("click", function() {
        clearBgColor();
    });  
    
    function clearAll(){
        clearPattern();
        clearBgColor();
    }
    
    
});//End ready